import { CircleX, FileCheck2 } from "lucide-react";
import FullscreenModalWrapper from "../../../components/modal/wrapper/fullscreen-modal-wrapper";
import InputField from "../../../components/form/input-field";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import ApiRequest from "../../../lib/ApiCall";
import { useEffect, useState } from "react";
import { EmptyFormInput, RolesOptionsType } from "../../../lib/helper-support"; 
import { SuccessFlash, ErrorFlash } from "../../../lib/flash-notification"; 
import SpinnerLoader from "../../../components/loader/spinner-loader";
import SelectField from "../../../components/form/select-field";

interface UserType{
    name: string,
    email: string,
    uuid: string,
    role:string
}

interface FormType {
    openModal: boolean,
    onSuccess: (data:any) => void,
    isEdit?: boolean,
    onCloseModal: () => void,
    data?:UserType,
}
const UserForm = ({
    openModal,
    onSuccess,
    onCloseModal,
    isEdit = false,
    data,
} : FormType) => {

    const [loadingSubmit, setLoadingSubmit] = useState(false);

    const formSchema = yup.object({
        name: yup.string().required(),
        email: yup.string().email().required(),
        role: yup.string().required(),
        password: isEdit ? yup.string().nullable() : yup.string().required(),
    });
    
    const {
        setValue,
        setError,
        formState: {errors},
        handleSubmit,
        getValues,
        reset,
    } = useForm({resolver: yupResolver(formSchema)}); 

    useEffect(()=> {
        reset(EmptyFormInput(formSchema));
        data && reset(data);
    }, [openModal]);

    const onSubmit = async (data:any) => {
        let request;
        setLoadingSubmit(true);
        if ( isEdit ){
            data['userId'] = data.uuid;
            request = await ApiRequest({endpoint: 'user/update', method: 'POST', payload: data});
        }else{
            request = await ApiRequest({endpoint: 'user', method: 'POST', payload: data});
        }

        setLoadingSubmit(false);

        if ( request.status === '200' ){
            onSuccess(request.data);
            SuccessFlash(isEdit ? 'User updated successfully' : 'User created successfully');
            return;
        }

        ErrorFlash(request.message);

        if (request.status === "payloadValidationError") {
            for (const [field, messages] of Object.entries(request.data)) {
                const input_field : any = field ;
                const error_message : any = messages
                setError(input_field, { type: "manual", message: error_message.join(", ") });
               // SmoothScroll();
            }
        }
        
    }

    return (
        <div>
            {openModal && 
            <FullscreenModalWrapper>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <button onClick={onCloseModal} className="absolute top-3 right-5">
                        <CircleX size={30}/>
                    </button>
                    <div className="flex items-center justify-between mt-10">
                        <h2>{isEdit ? `Edit User: ${data?.name}` : 'Create User'}</h2>
                        <div className="flex space-x-5">
                            
                            <button disabled={loadingSubmit} className={`${loadingSubmit && 'opacity-[0.5]'} pryBtn w-fit`}>
                                <FileCheck2 size={18}/>
                                <span>{isEdit ? 'Update' : 'Submit'}</span>
                                {loadingSubmit && <SpinnerLoader/>}
                            </button>
                        </div>
                    </div>
                    <div className="grid gap-4 mt-5">
                        <InputField
                            label="Name"
                            error={errors.name?.message}
                            onChangeInput={(e) => [setValue('name', e.target.value), setError('name', {message: ''})]}
                            value={getValues('name')}
                        />
                        <InputField
                            label="Email"
                            error={errors.email?.message}
                            onChangeInput={(e) => [setValue('email', e.target.value), setError('email', {message: ''})]}
                            value={getValues('email')}
                        />
                        <InputField
                            label="Password"
                            type="password"
                            error={errors.password?.message}
                            onChangeInput={(e) => [setValue('password', e.target.value), setError('password', {message: ''})]}
                            value={getValues('password') ?? ''}
                        />
                        <SelectField
                            label="Role"
                            error={errors.role?.message}
                            onChangeInput={(e) => [setValue('role', e.target.value), setError('role', {message: ''})]}
                            value={getValues('role')}
                            options={RolesOptionsType}
                        />
                    </div>
                </form>
            </FullscreenModalWrapper>}
        </div>
    );
}

export default UserForm